export default __webpack_public_path__ + "ed038db.png";